import React from 'react';
import { Play, Zap, ChevronRight } from 'lucide-react';
import { Button } from '../ui/button';
import { scrollToSection } from './scroll';

export const VideoHighlight = () => (
      <section className="py-12 bg-gray-100">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-5xl mx-auto">
            <div className="grid md:grid-cols-2 gap-8 items-center">
              {/* Video */}
              <div className="relative rounded-2xl overflow-hidden shadow-xl border-2 border-yellow-400">
                <video 
                  className="w-full aspect-video object-cover"
                  controls
                  poster="https://customer-assets.emergentagent.com/job_jetco-electrical/artifacts/lexucu1m_20260101_202034.jpg"
                  playsInline
                >
                  <source src="https://customer-assets.emergentagent.com/job_jetco-electrical/artifacts/xmaoan4i_VID_20260105_201828_845_bsl.mp4" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
                <div className="absolute top-3 left-3 bg-yellow-400 text-black font-bold px-3 py-1 rounded-full text-xs shadow-lg flex items-center">
                  <Play className="w-3 h-3 mr-1" />
                  WATCH NOW
                </div>
              </div>
              
              {/* Text Content */}
              <div className="space-y-4">
                <div className="inline-block bg-yellow-400/20 border border-yellow-500 text-yellow-600 font-bold px-4 py-2 rounded-full text-sm">
                  <Zap className="w-4 h-4 inline mr-2" />
                  Featured Project
                </div>
                <h2 className="text-2xl md:text-3xl font-bold text-gray-900">EV Charger Installation</h2>
                <p className="text-gray-600">Watch our team professionally install a Tesla Wall Connector. Quality workmanship, clean installation, ready to charge.</p>
                <div className="flex flex-wrap gap-3">
                  <span className="bg-gray-200 text-gray-700 px-3 py-1 rounded-full text-sm">Tesla Certified</span>
                  <span className="bg-gray-200 text-gray-700 px-3 py-1 rounded-full text-sm">Same-Day Install</span>
                  <span className="bg-gray-200 text-gray-700 px-3 py-1 rounded-full text-sm">Code Compliant</span>
                </div>
                <Button 
                  onClick={() => scrollToSection('contact')}
                  className="bg-yellow-400 hover:bg-yellow-500 text-black font-bold shadow-lg"
                >
                  Get Your EV Charger Installed
                  <ChevronRight className="w-5 h-5 ml-2" />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>
);
